import React from 'react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Alert, Grid, Typography, TextField, Button, Divider, IconButton, Select, MenuItem, InputLabel, InputAdornment, Stack } from '@mui/material';
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Pagination } from '@mui/material';

import { Backdrop, CircularProgress } from '@mui/material';
import NoCrashIcon from '@mui/icons-material/NoCrash';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { AirplaneTicket, Person } from '@mui/icons-material';
import { ArrowBack } from '@mui/icons-material';
import PlacaVehiculoInput from './PlacaVehiculoInput';
import PlacaTrailerInput from './PlacaTrailerInput';
import PlacaMotoInput from './PlacaMotoInput';

import AlertComponent from '../../Alert';
import { useAuth } from '../../../../Auth/AuthContext';
import { getUniqueActiveCashbox, resolveAuthenticatedUser } from '../../../../utils/cashbox';
import { parseColombianMoneyInput } from '../../../../utils/money';
import { sessionRequestConfig } from '../../../../utils/csrf';
import { normalizeCustomerName, uppercaseCustomerNameInput } from '../../../../utils/customerInput';
import { getApiErrorMessage } from '../../../../utils/apiErrorMessage';
import { getVehicleYears } from '../../../../utils/vehicleYears';

import { useTheme } from '@emotion/react';

const tipos = ['Automovil', 'Motocicleta', 'Camión', 'Camioneta', 'Trailer', 'Contenedor', 'Trailer + Cabezote', 'Cabezote', 'Volco', 'Otro'];
const marcas = ["Peterbilt", "Daf", "Isuzu", "Foton", "Iveco", "Scania", "Hino", "Freightliner", "Kodia", "International", "ProStar", "Mack", "Kenworth", "Eagle", "Chevrolet", "Renault", "Mazda", "Toyota", "Hyundai", "Kia", "Ford", "Volkswagen", "Nissan", "Honda", "Suzuki", "Jeep", "Subaru", "BMW", "Mercedes-Benz", "Audi", "Peugeot", "Fiat", "Mitsubishi", "Land Rover", "Jaguar", "Volvo", "Mini", "Dodge", "BYD", "JAC", "SsangYong", "Otro"];
const colores = ["Blanco", "Negro", "Gris", "Plata", "Rojo", "Azul", "Verde", "Amarillo", "Marrón", "Beige", "Naranja", "Violeta"];

const tipos_documentos = ["CC","NIT","TI","PPT"]

const formatearClientes = (clientes) => {
  if (!clientes || clientes.length === 0) return ""; // Si no hay clientes

  const nombres = clientes.map((cliente) => cliente.nombre);

  if (nombres.length === 1) {
    return `de ${nombres[0]}`;
  }

  const ultimaParte = `y ${nombres[nombres.length - 1]}`;
  const nombresFormateados = nombres.slice(0, -1).join(", ");
  
  return `de ${nombresFormateados} ${ultimaParte}`;
};

const API_URL = process.env.REACT_APP_API_URL;

async function actualizarReporteDiario(valor) {  
  const hoy = new Date().toLocaleDateString('sv-SE', { timeZone: 'America/Bogota' })//`${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, "0")}-${String(fecha.getDate()).padStart(2, "0")}`;
  try {
      const response = await axios.get(`${API_URL}/reporte_diario/`);

      const reportes = await response.data, reporteHoy = reportes.find(r => r.fecha === hoy && r.tipo === "M-I");
      if (reporteHoy) {
          const nuevoValor = parseFloat(reporteHoy.valor) + Number(valor);
          await axios.put(`${API_URL}/reporte_diario/${reporteHoy.id}/`, { valor: nuevoValor } );
      } else {
          await axios.post(`${API_URL}/reporte_diario/`, { fecha: hoy, tipo: "M-I", valor: Number(valor) });
      }
  } catch (error) {
      console.error("Error en la actualización del reporte:", error);
  }

  try {
      const response = await axios.get(`${API_URL}/reporte_diario/`);

      const reportes = await response.data, reporteHoy = reportes.find(r => r.fecha === hoy && r.tipo === "M-V");
      if (reporteHoy) {
          await axios.put(`${API_URL}/reporte_diario/${reporteHoy.id}/`, { valor: Number(reporteHoy.valor) + 1 } );
      } else {
          await axios.post(`${API_URL}/reporte_diario/`, { fecha: hoy, tipo: "M-V", valor: 1 });
      }
  } catch (error) {
      console.error("Error en la actualización del reporte:", error);
  }
}

const EntradaMensualidad = ({handleChangePage, onCreatedRecord}) => {
  const modelos = getVehicleYears();
  const { user } = useAuth();
  const theme = useTheme();

  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const submitRef = React.useRef(false);

  const [observaciones, setObservaciones] = useState('')
  const [fechaFinal, setFechaFinal] = useState(null)
  const [fechaInicio, setFechaInicio] = useState(null)

  const [valor, setValor] = useState()

  const [newClienteData, setNewClienteData] = useState({
    nombre: '',
    apellidos: '',
    celular: '',
    tipo_documento: '',
    documento: '',
  });
  
  const [newVehiculoData, setNewVehiculoData] = useState({
    placa: '',
    tipo_vehiculo: '',
    modelo: '',
    marca: '',
    color: '',
    clientes: [],
  });

  const [cancelCreateCliente, setCancelCreateCliente] = useState(false);
  const [cancelCreateVehiculo, setCancelCreateVehiculo] = useState(false);

  const [fieldErrors, setFieldErrors] = useState({
    placa: false,
    tipo_vehiculo: false,
    modelo: false,
    marca: false,
    color: false,
    nombre: false,
    apellidos: false,
    celular: false,
    tipo_documento: false,
    documento: false,
    valor: false, // Nuevo estado para el error de valor
    fechaInicio: false, // Nuevo estado para el error de fechaInicio
    fechaFinal: false, // Nuevo estado para el error de fechaFinal
  });

  const validateFields = () => {
    const errors = {
      placa: newVehiculoData.placa.trim() === "",
      tipo_vehiculo: newVehiculoData.tipo_vehiculo === "",
      modelo: newVehiculoData.modelo === "",
      marca: newVehiculoData.marca === "",
      color: newVehiculoData.color === "",
      nombre: newClienteData.nombre === "",
      apellidos: newClienteData.apellidos === "",
      celular: newClienteData.celular === "",
      tipo_documento: newClienteData.tipo_documento === "",
      documento: newClienteData.documento === "",
      valor: !valor, // Validar si valor está vacío
      fechaInicio: !fechaInicio, // Validar si fechaInicio está vacía
      fechaFinal: !fechaFinal, // Validar si fechaFinal está vacía
    };
    setFieldErrors(errors);
    return !Object.values(errors).some((error) => error);
  };

  const handleClienteChange = (field, value) => {
    setNewClienteData((prev) => ({ ...prev, [field]: value }));
  };
  const handleVehiculoChange = (field, value) => {
    setNewVehiculoData((prev) => ({ ...prev, [field]: value }));
  };

  
    const [clienteSearch, setClienteSearch] = useState('');
    const [clienteSearchLoading, setClienteSearchLoading] = useState(false)
    const [vehiculoSearch, setVehiculoSearch] = useState('');
    const [vehiculoSearchLoading, setVehiculoSearchLoading] = useState(false)
  
  const [vehiculoResultados, setVehiculoResultados] = useState([]);
  const [vehiculoPage, setVehiculoPage] = useState(1);
  const [vehiculoCount, setVehiculoCount] = useState(0);

  const [clienteResultados, setClienteResultados] = useState([]);
  const [clientePage, setClientePage] = useState(1);
  const [clienteCount, setClienteCount] = useState(0);

  const [vehiculoSeleccionadoId, setVehiculoSeleccionadoId] = useState(null);
  const [clienteSeleccionadoId, setClienteSeleccionadoId] = useState(null);

  const buscarVehiculos = async (query, page = 1) => {
    if (!query) {
      setVehiculoResultados([]);
      return;
    }

    setVehiculoSearchLoading(true);
    try {
      const res = await axios.get(
        `${API_URL}/historial/?search=${query}&page=${page}`
      );

      const data = res.data?.results || res.data || [];

      setVehiculoResultados(data);
      setVehiculoCount(res.data?.count || data.length);

    } catch (error) {
      console.error(error);
    } finally {
      setVehiculoSearchLoading(false);
    }
  };

  useEffect(() => { // debounce para búsqueda de vehículos
    const delay = setTimeout(() => {
      if (vehiculoSearch.length > 2) {
        buscarVehiculos(vehiculoSearch, vehiculoPage);
      }
    }, 400);

    return () => clearTimeout(delay);
  }, [vehiculoSearch, vehiculoPage]);

  const buscarClientes = async (query, page = 1) => {
    if (!query) {
      setClienteResultados([]);
      return;
    }

    setClienteSearchLoading(true);
    try {
      const res = await axios.get(
        `${API_URL}/clientes/?search=${query}&page=${page}`
      );

      const data = res.data?.results || res.data || [];

      setClienteResultados(data);
      setClienteCount(res.data?.count || data.length);

    } catch (error) {
      console.error(error);
    } finally {
      setClienteSearchLoading(false);
    }
  };

  useEffect(() => { // debounce para búsqueda de clientes
    const delay = setTimeout(() => {
      if (clienteSearch.length > 2) {
        buscarClientes(clienteSearch, clientePage);
      }
    }, 400);

    return () => clearTimeout(delay);
  }, [clienteSearch, clientePage]);


  const [currentTime, setCurrentTime] = useState(new Date());

  // Actualizar la hora cada segundo
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const [selectedVehiculo, setSelectedVehiculo] = useState({});
  const [selectedCliente, setSelectedCliente] = useState({});

  const handleChangeSetCliente = (value) => {
    if (value === null) { setCancelCreateCliente(false); return; }
    setCancelCreateCliente(true);
    setSelectedCliente(value);
  }
  const handleChangeSetVehiculo = (value) => {
    if (value === null) { setCancelCreateVehiculo(false); return; }
    setCancelCreateVehiculo(true);
    let selected = {
      id: value?.id ?? null,
      placa: value?.placa ?? '',
      tipo_vehiculo: value?.tipo_vehiculo ?? '',
      modelo: value?.modelo ?? '',
      marca: value?.marca ?? '',
      color: value?.color ?? '',
      clientes: Array.isArray(value?.clientes) ? value.clientes : [],
    }

    setSelectedVehiculo(selected);
  }

  const handleSubmit = async () => {
    if (submitRef.current || loading) return;
    setSubmitError('');
    submitRef.current = true;
    setLoading(true);
    try {

      const authenticatedUser = await resolveAuthenticatedUser(API_URL, user);
      const cajaActual = await getUniqueActiveCashbox(API_URL, authenticatedUser);
      const canonicalValue = parseColombianMoneyInput(valor);
  
      // Crear el nuevo movimiento de caja
      let newCliente;
      let newVehiculo;
      if (cancelCreateCliente) { newCliente = selectedCliente; }
      else { newCliente = newClienteData }
      if (cancelCreateVehiculo) { newVehiculo = selectedVehiculo; }
      else { newVehiculo = newVehiculoData }

      const nuevoMovimiento = {
        tipo: "Ingreso",
        isME: 'mensualidad',
        monto: canonicalValue,
        observacion: `Ingreso por Creación Mensualidad (Cliente: ${newCliente.nombre} ${newCliente.apellidos} Vehiculo: ${newVehiculo.tipo_vehiculo} ${newVehiculo.color} ${newVehiculo.placa})`
      };
  
      let clienteResponse;

      if (cancelCreateCliente) clienteResponse = selectedCliente;
      else clienteResponse = await axios.post(`${API_URL}/clientes/`, newClienteData, { headers: { "Content-Type": "application/json" } });

      let clienteId;
      if (cancelCreateCliente) clienteId = clienteResponse.id;
      else clienteId = clienteResponse.data.id

      // ---------------------------------------------
      
      let vehiculoResponse;

      if (cancelCreateVehiculo) {
        vehiculoResponse = {
          ...selectedVehiculo,
          clientes: [...new Set([...(selectedVehiculo.clientes || []), clienteId])],
        };
      }
      else vehiculoResponse = await axios.post(`${API_URL}/historial/`,{ ...newVehiculoData, cliente_ids: [clienteId] },{ headers: { "Content-Type": "application/json" } });

      let vehiculoData;
      if (cancelCreateVehiculo) vehiculoData = vehiculoResponse; // Guardar datos del vehículo creado  
      else vehiculoData = vehiculoResponse.data;

      let yearI = fechaInicio.getFullYear();
      let monthI = String(fechaInicio.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
      let dayI = String(fechaInicio.getDate()).padStart(2, '0');

      let yearF = fechaFinal.getFullYear();
      let monthF = String(fechaFinal.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
      let dayF = String(fechaFinal.getDate()).padStart(2, '0');

      const nuevaMensualidad = await axios.post(
        `${API_URL}/mensualidades/`, 
        {
          historial: vehiculoData.id,
          cliente: clienteId,
          fecha_inicio: `${yearI}-${monthI}-${dayI}`,
          fecha_final: `${yearF}-${monthF}-${dayF}`,
          valor: canonicalValue,
          observaciones: observaciones === '' ? 'Nada' : observaciones,
          usuario: authenticatedUser.id,
          financial: {
            caja_id: cajaActual.id,
            movimiento: nuevoMovimiento,
          },
        },
        sessionRequestConfig()
      )

      const { clientes, ...resto } = vehiculoData;

      const vehiculosConClientesLlamadosDeOtraForma = {
        ...resto,
        cliente_ids: clientes,
      };

      if (cancelCreateVehiculo) await axios.put(`${API_URL}/historial/${vehiculoData.id}/`, vehiculosConClientesLlamadosDeOtraForma);

      await actualizarReporteDiario(canonicalValue);
      setOpenAlert(true);
      onCreatedRecord?.('Mensualidades', nuevaMensualidad.data.id);
    } catch (error) {
      validateFields();
      setSubmitError(getApiErrorMessage(
        error,
        'No fue posible registrar la mensualidad. Revise los datos e intente nuevamente.',
        ['historial', 'cliente', 'movimiento', 'usuario', 'placa', 'cliente_ids']
      ));
      console.error("Error al procesar la entrada:", error);
    } finally {
      submitRef.current = false;
      setLoading(false);
    }
  }

  const getClienteLabelColor = (field) => {
    return newClienteData[field] !== "" ? '#81c784' : '#1976d2'; // Verde si está completo
  };
  const getVehiculoLabelColor = (field) => {
    return newVehiculoData[field] !== "" ? '#81c784' : '#1976d2'; // Verde si está completo
  };

  const [combinedPlates, setCombinedPlates] = useState({ plateT: '', plateABC: '' });

  const handleCombinedPlates = (type, value) => {
    setCombinedPlates((prevPlates) => {
      const newPlates = { ...prevPlates, [type]: value };

      if (newPlates.plateT && newPlates.plateABC) {
        handleVehiculoChange('placa', `${newPlates.plateT}-${newPlates.plateABC}`.toUpperCase());
      }

      return newPlates;
    });
  };

  return (
    <>
      <Grid container spacing={2} sx={{ paddingTop: 2 }}>

        {/* Botón de flecha en la parte izquierda superior */}
        <Grid item xs={12} sx={{ position: 'relative' }}>
          <IconButton 
            color="primary" 
            sx={{
              position: 'absolute',
              left: 0, // Ajusta la posición horizontal
              top: 1, // Ajusta la posición vertical
              zIndex: 1, // Asegura que esté por encima de otros elementos
            }}
            onClick={() => {handleChangePage('None')}}
          >
            <ArrowBack />
          </IconButton>
        </Grid>

        <Backdrop
          open={loading}
          style={{ zIndex: 9999, color: '#fff' }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <Typography variant="h3" gutterBottom textAlign='center' width='100%' sx={{ paddingBottom: 1 }}>
          ENTRADA DE VEHICULOS MENSUALIDAD
          <NoCrashIcon sx={{ marginLeft: 1, marginBottom: 0, fontSize: 50 }} />
        </Typography>

        {/* Divider entre los inputs superiores y las secciones principales */}
        <Grid item xs={12}>
          <Divider sx={{ marginY: 2 }} />
        </Grid>

        <Grid item xs={12} sx={{ flexGrow: 1 }}>
          <Grid container spacing={4} sx={{ height: '100%' }}>
            {/* Sección izquierda: Cliente */}
            <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Grid container alignItems="center" justifyContent="center" marginBottom={1}>
                <Typography variant="h5" gutterBottom>
                  CLIENTE
                </Typography>
                <Person sx={{ marginRight: 1, marginBottom: 1 }} />
              </Grid>

                              <Typography variant="body2" gutterBottom>
                  Aprieta Enter para buscar el vehículo por placa o para registrar uno nuevo
                </Typography>
              <TextField
                fullWidth
                label="Buscar Cliente (Nombre o Documento)"
                value={clienteSearch}
                onChange={(e) => setClienteSearch(e.target.value)}
              />

              {cancelCreateCliente && (
                <Typography color="success.main">
                  Cliente encontrado ✔
                </Typography>
              )}

              {!cancelCreateCliente && clienteSearch && (
                <Typography color="warning.main">
                  No existe, se creará uno nuevo
                </Typography>
              )}

              {clienteResultados.length > 0 && (
                <>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Nombre</TableCell>
                          <TableCell>Documento</TableCell>
                          <TableCell>Celular</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {clienteResultados.map((cliente) => (
                          <TableRow
                            key={cliente.id}
                            hover
                            selected={clienteSeleccionadoId === cliente.id}
                            sx={{
                              cursor: 'pointer',
                              transition: '0.2s',
                              backgroundColor:
                                clienteSeleccionadoId === cliente.id
                                  ? 'rgba(25, 118, 210, 0.2)'
                                  : 'inherit',
                              '&:hover': {
                                backgroundColor:
                                  clienteSeleccionadoId === cliente.id
                                    ? 'rgba(25, 118, 210, 0.3)'
                                    : 'rgba(0,0,0,0.04)'
                              }
                            }}
                            onClick={() => {
                              setClienteSeleccionadoId(cliente.id);
                              handleChangeSetCliente(cliente);
                              setCancelCreateCliente(true);
                            }}
                          >
                            <TableCell>
                              {cliente.nombre} {cliente.apellidos}
                            </TableCell>
                            <TableCell>{cliente.documento}</TableCell>
                            <TableCell>{cliente.celular}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Pagination
                    count={Math.ceil(clienteCount / 10)}
                    page={clientePage}
                    onChange={(e, value) => setClientePage(value)}
                    sx={{ mt: 2 }}
                  />
                </>
              )}

              <Divider sx={{ marginY: 2 }} />
              <InputLabel sx={{ fontWeight: 'bold', marginBottom: 2  }}>SI NO ES ASÍ, REGISTRELO POR FAVOR</InputLabel>

              <InputLabel sx={{ color: getClienteLabelColor('nombre'), fontWeight: 'bold' }}>Nombre del Cliente</InputLabel>
              <TextField
                autoFocus
                label="Nombre"
                disabled={cancelCreateCliente}
                variant={cancelCreateCliente ? 'filled' : 'outlined'}
                fullWidth
                inputProps={{ maxLength: 30 }}
                value={newClienteData.nombre}
                onChange={(e) => {handleClienteChange('nombre', uppercaseCustomerNameInput(e.target.value))}}
                onBlur={() => handleClienteChange('nombre', normalizeCustomerName(newClienteData.nombre))}
                error={cancelCreateCliente ? null : fieldErrors.nombre}
                helperText={cancelCreateCliente ? null : (fieldErrors.nombre ? "Este campo es obligatorio" : "")}
              />

              <InputLabel sx={{ fontWeight: 'bold', color: getClienteLabelColor('apellidos') }}>Apellidos del Cliente</InputLabel>
              <TextField
                autoFocus
                label="Apellidos"
                disabled={cancelCreateCliente}
                variant={cancelCreateCliente ? 'filled' : 'outlined'}
                fullWidth
                inputProps={{ maxLength: 30 }}
                value={newClienteData.apellidos}
                onChange={(e) => {handleClienteChange('apellidos', uppercaseCustomerNameInput(e.target.value))}}
                onBlur={() => handleClienteChange('apellidos', normalizeCustomerName(newClienteData.apellidos))}
                error={cancelCreateCliente ? null : fieldErrors.apellidos}
                helperText={cancelCreateCliente ? null : fieldErrors.apellidos ? "Este campo es obligatorio" : ""}
              />

              <InputLabel sx={{ color: getClienteLabelColor('celular'), fontWeight: 'bold' }}>Celular del Cliente</InputLabel>
              <TextField
                autoFocus
                label="Celular"
                disabled={cancelCreateCliente}
                variant={cancelCreateCliente ? 'filled' : 'outlined'}
                fullWidth
                inputProps={{ maxLength: 30 }}
                sx={{ textTransform: 'uppercase' }}
                onChange={(e) => {handleClienteChange('celular', e.target.value)}}
                error={cancelCreateCliente ? null : fieldErrors.celular}
                helperText={cancelCreateCliente ? null : fieldErrors.celular ? "Este campo es obligatorio" : ""}
              />

              <InputLabel sx={{ color: getClienteLabelColor('tipo_documento'), fontWeight: 'bold' }}>Tipo de Documento del Cliente</InputLabel>
              <Select
                fullWidth
                value={newClienteData.tipo_documento || ''}
                disabled={cancelCreateCliente}
                variant={cancelCreateCliente ? 'filled' : 'outlined'}
                onChange={(e) => {handleClienteChange('tipo_documento', e.target.value)}}
                error={cancelCreateCliente ? null : fieldErrors.tipo_documento}
              >
                {tipos_documentos.map((tipo) => (
                  <MenuItem key={tipo} value={tipo}>
                    {tipo}
                  </MenuItem>
                ))}
              </Select> 
              {cancelCreateCliente ? <></> : (fieldErrors.tipo_documento && <Typography color="error">Este campo es obligatorio</Typography>)}  

              <InputLabel sx={{ color: getClienteLabelColor('documento'), fontWeight: 'bold' }}>Documento del Cliente</InputLabel>
              <TextField
                autoFocus
                label="Documento"
                disabled={cancelCreateCliente}
                variant={cancelCreateCliente ? 'filled' : 'outlined'}
                fullWidth
                inputProps={{ maxLength: 15 }}
                sx={{ textTransform: 'uppercase' }}
                onChange={(e) => {handleClienteChange('documento', e.target.value)}}
                error={cancelCreateCliente ? null : fieldErrors.documento}
                helperText={cancelCreateCliente ? null : fieldErrors.documento ? "Este campo es obligatorio" : ""}
              />
            </Grid>

            {/* Sección derecha: Vehículo */}
            <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Grid container alignItems="center" justifyContent="center" marginBottom={1}>
                <Typography variant="h5" gutterBottom>
                  VEHICULO
                </Typography>
                <DirectionsCarIcon sx={{ marginRight: 1, marginBottom: 1}} />
              </Grid>

                <Typography variant="body2" gutterBottom>
                  Aprieta Enter para buscar el vehículo por placa o para registrar uno nuevo
                </Typography>
              <TextField
                fullWidth
                label="Buscar Vehículo (Placa)"
                value={vehiculoSearch}
                onChange={(e) => setVehiculoSearch(e.target.value.toUpperCase())}
              />

              {cancelCreateVehiculo && (
                <Typography color="success.main">
                  Vehículo encontrado ✔
                </Typography>
              )}

              {!cancelCreateVehiculo && vehiculoSearch && (
                <Typography color="warning.main">
                  No existe, se creará uno nuevo
                </Typography>
              )}

              {vehiculoResultados.length > 0 && (
                <>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Placa</TableCell>
                          <TableCell>Tipo</TableCell>
                          <TableCell>Marca</TableCell>
                          <TableCell>Modelo</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {vehiculoResultados.map((vehiculo) => (
                          <TableRow
                            key={vehiculo.id}
                            hover
                            selected={vehiculoSeleccionadoId === vehiculo.id}
                            sx={{
                              cursor: 'pointer',
                              transition: '0.2s',
                              backgroundColor:
                                vehiculoSeleccionadoId === vehiculo.id
                                  ? 'rgba(25, 118, 210, 0.2)'
                                  : 'inherit',
                              '&:hover': {
                                backgroundColor:
                                  vehiculoSeleccionadoId === vehiculo.id
                                    ? 'rgba(25, 118, 210, 0.3)'
                                    : 'rgba(0,0,0,0.04)'
                              }
                            }}
                            onClick={() => {
                              setVehiculoSeleccionadoId(vehiculo.id);
                              handleChangeSetVehiculo(vehiculo);
                              setCancelCreateVehiculo(true);
                            }}
                          >
                            <TableCell>{vehiculo.placa}</TableCell>
                            <TableCell>{vehiculo.tipo_vehiculo}</TableCell>
                            <TableCell>{vehiculo.marca}</TableCell>
                            <TableCell>{vehiculo.modelo}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Pagination
                    count={Math.ceil(vehiculoCount / 10)}
                    page={vehiculoPage}
                    onChange={(e, value) => setVehiculoPage(value)}
                    sx={{ mt: 2 }}
                  />
                </>
              )}

              <Divider sx={{ marginY: 2 }} />
              <InputLabel sx={{ fontWeight: 'bold', marginBottom: 2  }}>SI NO ES ASÍ, REGISTRELO POR FAVOR</InputLabel>

              <InputLabel sx={{ color: getVehiculoLabelColor('tipo_vehiculo'), fontWeight: 'bold' }}>Tipo del Vehiculo</InputLabel>
              <Select
                fullWidth
                value={newVehiculoData.tipo_vehiculo || ''}
                disabled={cancelCreateVehiculo}
                variant={cancelCreateVehiculo ? 'filled' : 'outlined'}
                onChange={(e) => {handleVehiculoChange('tipo_vehiculo', e.target.value)}}
                error={cancelCreateVehiculo ? null : fieldErrors.tipo_vehiculo}
              >
                {tipos.map((tipo) => (
                  <MenuItem key={tipo} value={tipo}>
                    {tipo}
                  </MenuItem>
                ))}
              </Select>
              {cancelCreateVehiculo ? <></> : (fieldErrors.tipo_vehiculo && <Typography color="error">Este campo es obligatorio</Typography>)}  


              <InputLabel sx={{ color: getVehiculoLabelColor('placa'), fontWeight: 'bold' }}>Placa del Vehiculo</InputLabel>
              {newVehiculoData.tipo_vehiculo === 'Trailer' || newVehiculoData.tipo_vehiculo === 'Volco' ? (
                <PlacaTrailerInput 
                  onComplete={(value) => handleVehiculoChange('placa', value.toUpperCase())} 
                  error={cancelCreateVehiculo ? null : fieldErrors.placa} 
                  disabled={cancelCreateVehiculo} 
                />
              ) : newVehiculoData.tipo_vehiculo === 'Motocicleta' ? (
                <PlacaMotoInput 
                  onComplete={(value) => handleVehiculoChange('placa', value.toUpperCase())} 
                  error={cancelCreateVehiculo ? null : fieldErrors.placa} 
                  disabled={cancelCreateVehiculo} 
                />
              ) : newVehiculoData.tipo_vehiculo === 'Trailer + Cabezote' ? (
                <>
                <PlacaTrailerInput 
                  onComplete={(value) => handleCombinedPlates('plateT', value)} 
                  error={cancelCreateVehiculo ? null : fieldErrors.placa} 
                  disabled={cancelCreateVehiculo} 
                />
                <PlacaVehiculoInput 
                  onComplete={(value) => handleCombinedPlates('plateABC', value)} 
                  error={cancelCreateVehiculo ? null : fieldErrors.placa} 
                  disabled={cancelCreateVehiculo} 
                />
              </>
              ) : (
                <PlacaVehiculoInput 
                  onComplete={(value) => handleVehiculoChange('placa', value.toUpperCase())} 
                  error={cancelCreateVehiculo ? null : fieldErrors.placa} 
                  disabled={cancelCreateVehiculo} 
                />
              )}
               {cancelCreateVehiculo ? <></> : (fieldErrors.placa && <Typography color="error">Este campo es obligatorio</Typography>)}  


              <InputLabel sx={{ color: getVehiculoLabelColor('modelo'), fontWeight: 'bold' }}>Modelo del Vehiculo</InputLabel>
              <Select
                fullWidth
                value={newVehiculoData.modelo || ''}
                disabled={cancelCreateVehiculo}
                variant={cancelCreateVehiculo ? 'filled' : 'outlined'}
                onChange={(e) => {handleVehiculoChange('modelo', e.target.value)}}
                error={cancelCreateVehiculo ? null : fieldErrors.modelo}
              >
                {modelos.map((modelo) => (
                  <MenuItem key={modelo} value={modelo}>
                    {modelo}
                  </MenuItem>
                ))}
              </Select>
              {cancelCreateVehiculo ? <></> : (fieldErrors.modelo && <Typography color="error">Este campo es obligatorio</Typography>)}  

              <InputLabel sx={{ color: getVehiculoLabelColor('marca'), fontWeight: 'bold' }}>Marca del Vehiculo</InputLabel>
              <Select
                fullWidth
                value={newVehiculoData.marca || ''}
                disabled={cancelCreateVehiculo}
                variant={cancelCreateVehiculo ? 'filled' : 'outlined'}
                onChange={(e) => {handleVehiculoChange('marca', e.target.value)}}
                error={cancelCreateVehiculo ? null : fieldErrors.marca}
              >
                {marcas.map((marca) => (
                  <MenuItem key={marca} value={marca}>
                    {marca}
                  </MenuItem>
                ))}
              </Select>
              {cancelCreateVehiculo ? <></> : (fieldErrors.marca && <Typography color="error">Este campo es obligatorio</Typography>)}  

              <InputLabel sx={{ color: getVehiculoLabelColor('color'), fontWeight: 'bold' }}>Color del Vehiculo</InputLabel>
              <Select
                fullWidth
                value={newVehiculoData.color || ''}
                disabled={cancelCreateVehiculo}
                variant={cancelCreateVehiculo ? 'filled' : 'outlined'}
                onChange={(e) => {handleVehiculoChange('color', e.target.value)}}
                error={cancelCreateVehiculo ? null : fieldErrors.color}
              >
                {colores.map((color) => (
                  <MenuItem key={color} value={color}>
                    {color}
                  </MenuItem>
                ))}
              </Select>
              {cancelCreateVehiculo ? <></> : (fieldErrors.color && <Typography color="error">Este campo es obligatorio</Typography>)}  

            </Grid>
          </Grid>
        </Grid>
        
        <Grid item xs={12}>
            <InputLabel padding={0}>Observaciones</InputLabel>
            <TextField
               autoFocus
               fullWidth
               value={observaciones}
               defaultValue='Una bicicleta amarrada atras'
               inputProps={{ maxLength: 200 }}
               sx={{ textTransform: 'uppercase' }}
               onChange={(e) => {setObservaciones(e.target.value)}}
            />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom textAlign='center' width='100%' paddingTop={2}>MENSUALIDAD</Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Typography variant="subtitle2" sx={{ marginTop: 2 }}>DESDE:</Typography>
            <Stack>
              <DatePicker
                fullWidth
                variant='outlined'
                value={fechaInicio}
                onChange={(newValue) => { setFechaInicio(newValue); setFieldErrors((prev) => ({ ...prev, fechaInicio: false })); }} // Resetear el error al cambiar la fecha
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={fieldErrors.fechaInicio} // Mostrar error si el campo está vacío
                    helperText={fieldErrors.fechaInicio ? "Este campo es obligatorio" : ""} // Mensaje de error
                  />
                )}
              />
              {fieldErrors.fechaInicio && <Typography color="error">Este campo es obligatorio</Typography>}  
            </Stack>

            <Typography variant="subtitle2" sx={{ marginTop: 2 }}>HASTA:</Typography>
            <Stack>
              <DatePicker
                fullWidth
                variant='outlined'
                value={fechaFinal}
                onChange={(newValue) => { setFechaFinal(newValue); setFieldErrors((prev) => ({ ...prev, fechaFinal: false })); }} // Resetear el error al cambiar la fecha
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={fieldErrors.fechaFinal} // Mostrar error si el campo está vacío
                    helperText={fieldErrors.fechaFinal ? "Este campo es obligatorio" : ""} // Mensaje de error
                  />
                )}
              />
              {fieldErrors.fechaFinal && <Typography color="error">Este campo es obligatorio</Typography>}  
            </Stack>
          </LocalizationProvider>

          <TextField 
            autoFocus 
            label="Pago" 
            fullWidth
            type='text'
            inputMode='decimal'
            InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment>, maxLength: 10 }} 
            sx={{ textTransform: 'uppercase', marginTop: 2 }}
            onChange={(e) => setValor(e.target.value)}
            value={valor}
          />
          {fieldErrors.valor && <Typography color="error">Este campo es obligatorio</Typography>}  

        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1" color='grey' fontWeight='bold'>Se agregara automaticamente un movimiento con el dinero y la información de la Mensualidad, así que NO tendras que hacerlo tú mismo</Typography>
        </Grid>

        {/* Botón de sumisión */}
        <Grid item xs={12} sx={{ textAlign: 'center', marginTop: 3 }}>
          {submitError && (
            <Alert severity="error" sx={{ mb: 2, textAlign: 'left' }}>
              {submitError}
            </Alert>
          )}
          <Button variant={theme.palette.mode === 'dark' ? "outlined" : "contained"} color="primary" size="large" onClick={handleSubmit} disabled={loading}>
            Enviar ENTRADA
          </Button>
        </Grid>

        {/* Divider entre las secciones y el botón */}
        <Grid item xs={12}>
          <Divider sx={{ marginY: 1 }} />
        </Grid>
      </Grid>
      <AlertComponent open={openAlert} setOpen={setOpenAlert} text={'Entrada registrada'} severity='success' snack={true}/>
    </>
  );
};

export default EntradaMensualidad;
